import { FilterItem, FilterItemOperator } from '@mm/state/model/AudiencesModel';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import PrimarySelect from '../PrimarySelect/PrimarySelect';
import {
  AudienceFilterItemInputChildProps,
  MULTI_VALUES_OPERATORS,
} from './AudienceFilterItemInput';

export const AudienceFilterItemInputOperator = ({
  filter,
  setFilter,
  variableOperators,
  fetchingVariableOperators,
  busy,
  className,
  css,
}: AudienceFilterItemInputChildProps) => {
  const items = useMemo(
    () =>
      variableOperators
        ? variableOperators?.variableOperators?.map((item, i) => ({
            ...item,
            id: i,
          }))
        : [],
    [variableOperators],
  );
  const selectedItem = items?.find(i => i.value === filter.operator);

  const onChangeOperator = (operator: FilterItemOperator) => {
    let filterUpdates: Partial<FilterItem> = { operator };

    const operatorTakesMultiValues = MULTI_VALUES_OPERATORS.includes(operator);
    if (operatorTakesMultiValues !== Array.isArray(filter.value)) {
      filterUpdates = {
        ...filterUpdates,
        value: operatorTakesMultiValues ? [] : '',
      };
    }

    setFilter({
      ...filter,
      ...filterUpdates,
    });
  };

  return (
    <div
      className={classNames(
        'audience-filter-item-input__section',
        css?.section,
        {
          [`${className}__section`]: className,
        },
      )}
    >
      <div
        className={classNames(
          'audience-filter-item-input__field-title',
          css?.fieldTitle,
          {
            [`${className}__field-title`]: className,
          },
        )}
      >
        Operator
      </div>
      <PrimarySelect
        placeholder={
          fetchingVariableOperators ? (
            <>
              <i className="fas fa-spinner fa-spin" /> Loading operators
            </>
          ) : undefined
        }
        className={classNames(css?.select, {
          [`${className}__selector`]: className,
        })}
        activeItemClassName={classNames(css?.selectActiveItem, {
          [`${className}__operator-selector__active-item`]: className,
        })}
        value={selectedItem}
        onChange={item => onChangeOperator(item.value)}
        disabled={fetchingVariableOperators}
        options={items}
        customDropdownStyles={{ zIndex: '1000010' }}
        renderWithoutPopover
      />
    </div>
  );
};
